import React from "react";
import Search from "../SearchBar.js/Search";
export default function Dashboard() {
  return (
    <div className="py-20 items-center flex">
      <Search></Search>
    </div>
  );
}
